import requester from '@/utils/request'
export default {
  // 获取我邀请粉丝和创作者数量、收入
  queryInvitationAndIncome: () => requester.post('/shop/v2/queryInvitationAndIncome', {}, { headers: { isSeller: true } }),
  // 生成创作者邀请码
  queryInviteCode: () => requester.post('/shop/v1/generateInviteCode', {}, { headers: { isSeller: true } }),
  // 生成粉丝邀请码
  invitationCodeGenerate: () => requester.post('/actor/v1/invitation-code/generate', {}),
  // 获取我邀请的创作者和粉丝列表
  queryCreatorAndUserList: (data: any) => requester.post('/shop/v2/queryInviteCreatorAndUserList', data, { headers: { isSeller: true } }),
  // 获取我邀请的创作者列表
  queryMyInviteShops: () => requester.post('/shop/v2/queryMyInviteShops', {}, { headers: { isSeller: true } }),
  // 获取我邀请的粉丝列表
  queryMyInviteUsers: (data: any) => requester.post('/shop/v2/queryMyInviteUsers', data, { headers: { isSeller: true } }),
  // 获取可提现金额
  canWithdrawAmount: (data: any) => requester.post('/award/v1/canWithdrawAmount', data, { headers: { isSeller: true } }),
  // 获取可提现金额(eth, dollar)：邀请粉丝可提现美金收入、邀请创作者可提现美金收入
  canWithdrawAmountAll: (data: any) => requester.post('/award/v1/canWithdrawAmountAll', data, { headers: { isSeller: true } }),
  // 提现
  withdraw: (data: any) => requester.post('/award/v1/withdraw', data, { headers: { isSeller: true } }),
}
